import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onBeforeMount,
  ref,
  defineAsyncComponent,
  nextTick,
  onMounted,
  onBeforeUnmount,
  watch,
} from 'vue';
import type { Ref } from 'vue';
import { DotsLoader } from 'ui-shared-components';
import { FlightInfo } from '@white-label-types/search-box';


export default /*#__PURE__*/_defineComponent({
  __name: 'flight-search-dropdown',
  props: {
    value: { default: () => ({}) },
    items: { default: () => [] },
    requestStatus: null,
    title: { default: '' },
    id: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ['input', 'modalTrigger', 'update:show'],
  setup(__props: any, { emit }) {

const props = __props as { value: Object, items: Array<object>, requestStatus: 'empty' | 'loading' | 'success' | 'error', title: string, id?: string, disabled: boolean };

const IconButton = defineAsyncComponent(
  () => import('@white-label-icon/icon-button')
);
const IconAlert = defineAsyncComponent(
  () => import('@white-label-icon/icon-alert')
);



const input: Ref<string> = ref('');
const textInput: Ref<HTMLInputElement | null> = ref(null);
const selected: Ref<FlightInfo | {}> = ref({});
const isFlightSelected = computed(
  () => selected.value.flightNumber !== undefined
);
const showDropdown: Ref<boolean> = ref(false);



const filteredList = computed(() => {
  if (!input.value || input.value.length < 2) return props.items;
  return props.items.filter(
    (item) =>
      item.airport.toLowerCase().includes(input.value.toLowerCase()) ||
      item.airline.toLowerCase().includes(input.value.toLowerCase()) ||
      item.flightNumber.toLowerCase().includes(input.value.toLowerCase())
  );
});

const selectItem = (item, emitUpdate = true) => {
  selected.value = item;
  if (emitUpdate) {
    emit('input', item);
  }
  showDropdown.value = false;
};

const showDisabledWarning = ref<boolean>(false);

const initInput = async () => {
  if (props.disabled) {
    showDisabledWarning.value = true;
    return;
  }
  input.value = '';
  showDropdown.value = true;
  await nextTick();
  textInput.value.focus();
};

const blurTriggerInput = () => {
  if (showDisabledWarning.value) showDisabledWarning.value = false;
}

const cantFindFlight = () => {
  showDropdown.value = false;
  emit('modalTrigger');
};

const handleClose = () => {
  showDropdown.value = false;
};

const handleFocusOut = (e) => {
  const target = e.composedPath()[0];
  if (
    target &&
    target.attributes.getNamedItem('data-opens-dropdown')?.value === 'true'
  ) {
    return;
  }
  input.value = '';
  showDropdown.value = false;
};

const handleClickOutside = (e) => {
  const target = e.composedPath()[0];
  if (
    target &&
    target.attributes.getNamedItem('data-opens-dropdown')?.value === 'true'
  ) {
    return;
  }

  if (
    textInput.value &&
    !textInput.value.contains(target) &&
    !target.closest('.dropdown-list') &&
    !target.classList.contains('flight-display')
  ) {
    input.value = '';
  }
  showDropdown.value = false;
};

watch(
  () => props.value,
  (val) => {
    selected.value = val;
  }
);

const flightDisplay = computed(() =>
  selected.value.flightNumber
    ? `${selected.value.terminal} - ${selected.value.date} - ${selected.value.time} - ${selected.value.airport}`
    : 'Search by flight number'
);

const isDisabled = computed(() => props.disabled);
const isLoading = computed(() => props.requestStatus === 'empty' || props.requestStatus === 'loading');
const isSuccess = computed(() => props.requestStatus === 'success');

const showDisplay = computed(() => !showDropdown.value && isFlightSelected.value);
const showTriggerInput = computed(() => !showDropdown.value);
const showDropdownInput = computed(() => showDropdown.value && !props.disabled);
const showCantFindFlight = computed(() => isSuccess.value && props.items.length > 0);
const showNoResultsFound = computed(() => isSuccess.value && props.items.length === 0);

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeMount(function () {
  selectItem(props.value, false);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return { __sfc: true,IconButton, IconAlert, props, input, textInput, selected, isFlightSelected, showDropdown, emit, filteredList, selectItem, showDisabledWarning, initInput, blurTriggerInput, cantFindFlight, handleClose, handleFocusOut, handleClickOutside, flightDisplay, isDisabled, isLoading, isSuccess, showDisplay, showTriggerInput, showDropdownInput, showCantFindFlight, showNoResultsFound, DotsLoader }
}

})